import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ee70eb22&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style1 from "./App.vue?vue&type=style&index=1&id=ee70eb22&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee70eb22",
  null
  
)

export default component.exports